<div class="contentContainer scaleToolContainer">
  <app-show-scale *ngIf="data.componentFlag === 'show'"></app-show-scale>
  <app-print-scale *ngIf="data.componentFlag === 'print'"></app-print-scale>
</div>
